// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright vis.gl contributors
import { parseOBJ } from "./lib/parse-obj.js";
import { OBJLoader as OBJWorkerLoader } from "./obj-loader.js";
import { parseMTL } from "./lib/parse-mtl.js";
import { MTLLoader as MTLWorkerLoader } from "./mtl-loader.js";
export { OBJWorkerLoader };
/**
 * Loader for the OBJ geometry format
 */
export const OBJLoader = {
    ...OBJWorkerLoader,
    parse: async (arrayBuffer, options) => parseOBJ(new TextDecoder().decode(arrayBuffer), options),
    parseTextSync: (text, options) => parseOBJ(text, options)
};
// MTLLoader
/**
 * Loader for the MTL material format
 */
export const MTLLoader = {
    ...MTLWorkerLoader,
    parse: async (arrayBuffer, options) => parseMTL(new TextDecoder().decode(arrayBuffer), options?.mtl),
    parseTextSync: (text, options) => parseMTL(text, options?.mtl)
};
